import React, { FC, useEffect, useState } from 'react';
import  styles from './GuestsMobile.module.scss';
import { Room } from '../Guests/GuestsSelector';
import { useConfig } from '@/context/ConfigContext';
import { useTranslations } from 'next-intl';
import Remove from '@/components/icons/Remove';
import Counter from '../../Counter/Counter';
import DownwardArrow from '@/components/icons/DownwardArrow';
import Increment from '@/components/icons/Increment';


interface GuestsMobileProps {
  onApply: (rooms: Room[]) => void;
  rooms: Room[];
  onClose: () => void;
}

const GuestsMobile: FC<GuestsMobileProps> = ({
  onApply,
  rooms: roomsValue,
  
}) => {
    const { config } = useConfig();
      const t= useTranslations('guests');
    
    const limits = {
      max_adults: config.config.limits?.room_adults_max,
      min_adults: config.config.limits?.room_adults_min,
      max_children: config.config.limits?.room_children_max,
      min_children: config.config.limits?.room_children_min,
      max_room_guests: config.config.limits?.room_personnel_max,
      max_rooms: config.config.limits?.rooms_max,
      default_child_age: config.config.limits?.room_child_age_default
    };
  
    const [rooms, setRooms] = useState<Room[]>(roomsValue);
  
  
    const updateAndApply = (updatedRooms: Room[]) => {
      setRooms(updatedRooms);
      onApply(updatedRooms);
    };
  
    const canAddRoom = rooms.length < limits.max_rooms;

    const addRoom = () => {
      if (rooms.length < limits.max_rooms) {
        updateAndApply([...rooms, { adults: 1, children: [] }]);
      }
    };
  
    const removeRoom = (index: number) => {
      const updatedRooms = rooms.filter((_, i) => i !== index);
      updateAndApply(updatedRooms);
    };
  
    const updateRoom = (index: number, adults: number, children: number[]) => {
      const updatedRooms = rooms.map((room, i) =>
        i === index ? { adults, children } : room
      );
      updateAndApply(updatedRooms);
    };
  
    const handleChildrenChange = (roomIndex: number, childIndex: number, age: number) => {
      const updatedRooms = rooms.map((room, i) => {
        if (i === roomIndex) {
          const updatedChildren = room.children.map((childAge, j) =>
            j === childIndex ? age : childAge
          );
          return { ...room, children: updatedChildren };
        }
        return room;
      });
      updateAndApply(updatedRooms);
    };
  
  
  
    
  return (
    <div className={styles.GuestsMobile} data-testid="Guests">


      {rooms.map((room, roomIndex) => (
        <div
          key={roomIndex}
          className={`${styles.roomContainer} ${roomIndex === rooms.length - 1 ? styles.lastRoom : ""}`}
        >
          <div className={styles.roomHeader}>
            <p className={styles.roomApplytext}>{t('room')} {roomIndex + 1}</p>

            {roomIndex > 0 && (
              <button
                onClick={(event) => {
                  event.preventDefault();
                  removeRoom(roomIndex)
                }}
                className="w-4"
              >
                <Remove color="#1E2F56"/>
              </button>
            )}
          </div>
          <div className={styles.counters}>
            <Counter
              title={t('adults')}
              count={room.adults}
              disableIncrement={
                room.adults >= limits.max_adults ||
                room.adults + room.children.length >= limits.max_room_guests
              }
              disableDecrement={room.adults <= limits.min_adults}
              onDecrease={() =>
                updateRoom(roomIndex, room.adults - 1, room.children)
              }
              onIncrease={() =>
                updateRoom(roomIndex, room.adults + 1, room.children)
              }
            />
            <Counter
              title={t('children')}
              count={room.children.length}
              disableIncrement={
                room.children.length >= limits.max_children ||
                room.adults + room.children.length >= limits.max_room_guests
              }
              disableDecrement={room.children.length <= limits.min_children}
              onDecrease={() =>
                updateRoom(roomIndex, room.adults, room.children.slice(0, -1))
              }
              onIncrease={() =>
                updateRoom(roomIndex, room.adults, [...room.children, limits?.default_child_age])
              }
            />
          </div>
          <div className={styles.childAgeContainer}>
            {room.children.map((childAge, childIndex) => (
              <div key={childIndex} className={styles.childAgeSelector}>
                <label htmlFor={`childAge-${roomIndex}-${childIndex}`} >{t('age')}</label>
                <div className={styles.selectContainer}>
                  <select
                    id={`childAge-${roomIndex}-${childIndex}`}
                    value={childAge}
                    onChange={(e) =>
                      handleChildrenChange(roomIndex, childIndex, parseInt(e.target.value))
                    }

                  >

                    {Array.from({ length: 13 }, (_, i) => (
                      <option key={i} value={i}>
                        {i}
                      </option>
                    ))}

                  </select>
                  <DownwardArrow className={`absolute top-[50%] end-[10px] ${styles.DownArrowicon}`} />
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
      <button
        onClick={(event) => {
          event.preventDefault();
          addRoom();
        }}
        disabled={!canAddRoom}
        className={`${styles.addRoomButton} rtl:flex-row-reverse`}
      >
        <span className={styles.addText}>{t('addRoom')}</span>
        <span >
          <Increment />
        </span>
      </button>
    </div>
  );
};



export default GuestsMobile;
